
import React from "react";

const SatDreamz = () => {
  return <div>SatDreamz Page</div>;
};

export default SatDreamz;
